import React from 'react';
import { connect } from 'react-redux';

import googleConfig from 'config/services/google';
import { getTranslatedString } from 'helpers/i18n';

const style = {
  badge: {
    textAlign: 'center',
    fontSize: '11px',
    lineHeight: '15px',
    borderRadius: '3px',
    color: '#fff',
    display: 'inline-block',
    padding: '1px 6px',
    marginBottom: '5px',
  },
};

class GoogleCalConnect extends React.Component {
  render() {
    const googleStatus = this.props.googleConnected
      ? getTranslatedString('landlordPortal.CalendarIntegrations.status.active')
      : getTranslatedString('landlordPortal.CalendarIntegrations.status.inActive');

    return (
      <div className="row" style={{ textAlign: 'center', marginTop: '25px' }}>
        {this._renderIsActive(googleStatus)}
        {this._renderConnectButton()}
      </div>
    );
  }

  _renderIsActive = googleStatus => (
    <div className="row" style={{ textAlign: 'center' }}>
      <span className={this.props.googleConnected ? 'closed' : 'pending'} style={style.badge}>
        {getTranslatedString('landlordPortal.CalendarIntegrations.google.status', {
          status: googleStatus,
        })}
      </span>
    </div>
  );

  _renderConnectButton() {
    if (this.props.googleConnected) return null;

    return (
      <div className="row">
        <h5 style={{ textAlign: 'center', marginTop: '20px' }}>
          <button
            type="button"
            className="link-button"
            onClick={this.props.redirectToOAuth(googleConfig)}
          >
            {getTranslatedString('landlordPortal.CalendarIntegrations.google.connect')}
          </button>
        </h5>
      </div>
    );
  }
}

export default connect(state => ({
  googleConnected: state.userTypes.googleConnected,
}))(GoogleCalConnect);
